import React from 'react';
import { Badge } from '../ui/badge';
import { WorkOrderStatus } from '../../lib/types';
interface StatusBadgeProps {
  status: WorkOrderStatus;
}
export function StatusBadge({
  status
}: StatusBadgeProps) {
  let variant: 'default' | 'secondary' | 'destructive' | 'outline' = 'default';
  let className = '';
  switch (status) {
    case 'Osnutek':
      variant = 'secondary';
      className = 'bg-slate-100 text-slate-700 hover:bg-slate-200';
      break;
    case 'V delu':
      variant = 'default';
      className = 'bg-blue-100 text-blue-700 hover:bg-blue-200';
      break;
    case 'Zaključeno':
      variant = 'default';
      className = 'bg-green-100 text-green-700 hover:bg-green-200';
      break;
    case 'Stornirano':
      variant = 'destructive';
      className = 'bg-red-100 text-red-700 hover:bg-red-200';
      break;
  }
  return <Badge variant={variant} className={className} data-id="element-170">
      {status}
    </Badge>;
}